/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Form, Select, Button, Spin, Table, Tag, message, Input } from "antd";
import { useNavigate } from "react-router-dom";
import API from "../../api";
import urls from "../../api/urls";
import back_img from "../../assests/images/rightVector.svg";
import Smcs_Loader from "../../assests/images/loader-new.gif";

const { Option } = Select;
const { TextArea } = Input;

// Parse comma/newline/space-separated AWBs into a clean array
const parseAwbs = (raw) =>
  raw
    .split(/[\n,\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);

const resultColumns = [
  {
    title: "AWB Number",
    dataIndex: "awbNumber",
    key: "awbNumber",
  },
  {
    title: "Result",
    dataIndex: "result",
    key: "result",
    render: (result) =>
      result === "SUCCESS" ? (
        <Tag color="green">Success</Tag>
      ) : (
        <Tag color="red">Failed</Tag>
      ),
  },
  {
    title: "Reason",
    dataIndex: "reason",
    key: "reason",
    render: (reason) => reason || "—",
  },
];

function MarkLostDamage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = useState([]);

  const onFinish = async (values) => {
    const awbNumbers = parseAwbs(values.awbNumbers);
    if (awbNumbers.length === 0) {
      message.warning("Please enter at least one AWB number.");
      return;
    }

    const userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
    const premiseId = userInfo?.userInfo?.premiseId;
    const userId = userInfo?.userInfo?.userId;

    setLoading(true);
    try {
      const payload = {
        awbNumbers,
        status: values.status,
        premiseId,
        userId,
        ...(values.remark ? { remark: values.remark.trim() } : {}),
      };

      const response = await API.Api(urls.MARK_SHIPMENT_LOST_DAMAGE).postIdHeader(payload);
      const resData = response?.response?.data;
      const httpStatus = response?.response?.status;

      if (httpStatus === 200 || httpStatus === 207) {
        // Build per-AWB result rows
        const successSet = new Set(resData?.successfulAwbs || []);
        const failureMap = {};
        (resData?.failures || []).forEach((f) => {
          failureMap[f.awbNumber] = f.reason;
        });

        const rows = awbNumbers.map((awb, idx) => ({
          key: idx,
          awbNumber: awb,
          result: successSet.has(awb) ? "SUCCESS" : "FAILED",
          reason: failureMap[awb] || null,
        }));

        setResultData(rows);

        if (httpStatus === 200) {
          message.success(resData?.message || `All ${awbNumbers.length} shipment(s) updated successfully.`);
        } else {
          message.warning(resData?.message || `Partially updated: ${resData?.successCount} success, ${resData?.failureCount} failed.`);
        }
        form.resetFields();
      } else {
        message.error(
          resData?.message || "Failed to update shipment status. Please try again."
        );
      }
    } catch {
      message.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", background: "#F8FAFC", minHeight: "100vh" }}>
      <div
        style={{
          background: "#fff",
          padding: "16px 24px",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: "24px", display: "flex", alignItems: "center" }}>
          <img
            src={back_img}
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer", marginRight: "8px" }}
            alt="back"
          />
          <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#101828" }}>
            Mark Lost / Damaged
          </h1>
        </div>

        {/* Form */}
        <Spin
          spinning={loading}
          indicator={
            <img src={Smcs_Loader} style={{ height: "80px", width: "80px" }} alt="Loading..." />
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
            className="global-form"
            style={{ maxWidth: 520 }}
          >
            <Form.Item
              label="AWB Number(s)"
              name="awbNumbers"
              extra="Enter one or multiple AWB numbers, separated by comma, space, or new line."
              rules={[{ required: true, message: "Please enter at least one AWB number" }]}
            >
              <TextArea
                placeholder={"e.g. 18066495615298\n18066495615299, 18066495615300"}
                rows={4}
                style={{ borderRadius: "8px", fontFamily: "monospace" }}
              />
            </Form.Item>

            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: "Please select a status" }]}
            >
              <Select
                placeholder="Select status"
                size="large"
                style={{ borderRadius: "8px" }}
              >
                <Option value="LOST">Lost</Option>
                <Option value="DAMAGED">Damaged</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Remark"
              name="remark"
            >
              <TextArea
                placeholder="Optional — reason for marking as lost/damaged"
                rows={2}
                maxLength={255}
                showCount
                style={{ borderRadius: "8px" }}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={loading}
                style={{
                  background: "#175EB6",
                  borderRadius: "8px",
                  fontWeight: "600",
                  paddingInline: 32,
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Spin>

        {/* Results */}
        {resultData.length > 0 && (
          <div style={{ marginTop: "24px" }}>
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#101828",
                marginBottom: "12px",
              }}
            >
              Results
            </h2>
            <Table
              columns={resultColumns}
              dataSource={resultData}
              pagination={false}
              size="middle"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default MarkLostDamage;
